import React from 'react'
import Popup from "reactjs-popup";
import {getMobileOperatingSystem, OS} from "../../../utils/CheckPlatform";
import {Col, Container, Row} from "react-grid-system";
import AndroidLogo from "../LandingPage/platformSection/android/AndroidLogo";
import IosLogo from "../LandingPage/platformSection/ios/IosLogo";
import {Drawable} from "../../../res/images/Drawable";
import {LinkProvider} from "../../../res/LinkProvider";

interface SelectPlatformDialogProp {
    buttonUI: JSX.Element;
    callback: ((os: OS) => void)
}

export function SelectPlatformDialog(props: SelectPlatformDialogProp) {

    let openDocument = (url: string) => {
        window.open(url)
    }

    let openIosDocument = () => {
        openDocument(LinkProvider.latestIosDocument)
    }

    let openAndroidDocument = () => {
        openDocument(LinkProvider.latestAndroidDocument)
    }

    let popup = (
        <Popup
            trigger={props.buttonUI}
            modal={true}
            closeOnDocumentClick={true}>
            {(close: (() => void)) => (
                <Container>
                    <a>
                        <img
                            onClick={close}
                            className="closeButton"
                            src={Drawable.close}/>
                    </a>
                    <Row>
                        <p
                            className="popupTitle">
                            Select your device
                        </p>
                    </Row>
                    <Row>
                        <Col
                            className="popupOption">
                            <a
                                onClick={
                                    () => {
                                        openAndroidDocument();
                                        close();
                                    }
                                }>
                                <AndroidLogo/>
                            </a>
                        </Col>
                        <Col
                            className="popupOption">
                            <a
                                onClick={
                                    () => {
                                        openIosDocument();
                                        close()
                                    }
                                }>
                                <IosLogo/>
                            </a>
                        </Col>
                    </Row>
                </Container>
            )}
        </Popup>
    )

    let directDownload = (action: () => void) => (
        <div
            onClick={action}>
            {props.buttonUI}
        </div>
    )

    switch (getMobileOperatingSystem()) {
        case OS.android:
            return directDownload(openAndroidDocument)
        case OS.iOS:
            return directDownload(openIosDocument)
        //case OS.unknow:
        default:
            return popup;

    }

}
